import * as t from "react";
const u = (f, s) => {
  const e = t.useRef(!1);
  t.useEffect(() => {
    e.current ? f() : e.current = !0;
  }, s);
};
export {
  u as default
};
//# sourceMappingURL=useDidMountEffect.es.js.map
